class ResponsiveVideo {
    constructor(element) {
        this.element = element;
        this.sources = [];
        this.init();
    }
    init() {
        var _a;
        this.sources = Array.from((_a = this.element.querySelectorAll("source")) !== null && _a !== void 0 ? _a : []).map((source) => {
            var _a;
            return ({
                url: (_a = source.dataset.src) !== null && _a !== void 0 ? _a : source.src,
                media: source.media || "default",
            });
        });
        if (this.sources.length < 1) {
            console.warn("[ResponsiveVideo] Sources not found");
            return false;
        }
        this.run();
        window.addEventListener("resize", this.run.bind(this), { passive: true });
        return true;
    }
    run() {
        const matchedQueries = this.sources
            .filter((source) => source.media !== "default")
            .filter((source) => window.matchMedia(source.media).matches)
            .reverse();
        if (matchedQueries && matchedQueries.length > 0) {
            if (this.element.src !== matchedQueries[0].url) {
                this.element.src = matchedQueries[0].url;
            }
            return true;
        }
        this.setDefault();
        return true;
    }
    setDefault() {
        var _a, _b;
        const defaultVideo = this.sources.find((src) => src.media === "default");
        const url = (_a = defaultVideo === null || defaultVideo === void 0 ? void 0 : defaultVideo.url) !== null && _a !== void 0 ? _a : this.sources[0].url;
        if (this.element.src !== url) {
            this.element.src = (_b = defaultVideo === null || defaultVideo === void 0 ? void 0 : defaultVideo.url) !== null && _b !== void 0 ? _b : this.sources[0].url;
        }
        return true;
    }
}
export default ResponsiveVideo;
